var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{style:(this.$vuetify.breakpoint.smAndDown ? '' : 'width: 870px;')},[_c('div',{attrs:{"id":"history"}},[_c('HistorySearch')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }